<svg-icon
  class="max-payout__bg"
  src="assets/images/ui-effects/background-vector.svg"
></svg-icon>
<div class="max-payout__label">Max Payout</div>
<div class="max-payout__value">
  <app-balance-icon
    size="20px"
    color="var(--yellow)"
    balance="pure"
  ></app-balance-icon>
  <span>{{ maxPayout() | number : "1.0-0" }}</span>
</div>
